<script>
// import lazyLoadComponent from '@router/lazyload-component'
import { merchantComputed, authComputed } from '@state/helpers'

export default {
  components: {
    // BaseInputFloatingLabel: () => import('@components/BaseInputFloatingLabel'),
    // BaseUpload: () => import('@components/BaseUpload'),
    // ImageUpload: () => lazyLoadComponent(import('@views/chat/components/FileUpload')),
  },
  props: {
    products: {
      type: Array,
      required: true,
    },
    category: {
      type: Array,
      required: true,
    },
    defaultValue: {
      type: Object,
      default: () => {},
    },
    tagList: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      // submitData: this.defaultValue,
      // limit:{
      //   year:0,
      //   month:0,
      //   day:0
      // }
    }
  },
  computed: {
    ...merchantComputed,
    ...authComputed,
    submitData: {
      get() {
        return this.defaultValue
      },
      set(value) {
        this.$emit('update:defaultValue', value)
      },
    },
    canSetPrice() {
      return this.$can('api', 'setPrice')
    },
    formRules() {
      return {
        title: [
          {
            required: true,
            message: `請輸入${this.$t('prepaid.BASE')}方案名稱`,
          },
        ],
        categoryId: [
          {
            required: true,
            message: '請選擇類別',
          },
        ],
        groupAlias: [
          {
            required: true,
            message: `請輸入${this.$t('prepaid.BASE')}網址別名`,
          },
        ],
        // basePrice: [
        //   {
        //     required: true,
        //     message: '請輸入原價',
        //     // trigger: 'change',
        //   },
        // ],
        // price: [
        //   {
        //     required: true,
        //     message: '請輸入售價',
        //     // trigger: 'change',
        //   },
        // ],
        times: [
          {
            required: true,
            message: '請輸入可抵扣次數',
            // trigger: 'change',
          },
        ],
        infinity: [
          {
            required: true,
            message: '請選擇庫存數量',
            // trigger: 'change',
          },
          {
            validator: (rule, value, callback) => {
              if (this.submitData.infinity === 0) {
                const reg = /^\d+$/
                if (!reg.test(this.submitData.inventory)) {
                  callback(new Error('請輸入數字'))
                }
                if (this.submitData.inventory < 0) {
                  callback(new Error('請輸入大於等於0'))
                }
              }
              callback()
            },
          },
        ],
      }
    },
    currentCategory() {
      return this.category.filter((item) => {
        return item.children.length > 0
      })
    },
    isEditMode() {
      return !!this.defaultValue.groupOrdering
    },
    productBaseBookingUrl() {
      // return `${this.merchantUrl}/booking/${this.currentProductAlias}/`
      let url = ''
      if (window.globalData.APP_ENV === 'local') {
        url = this.merchantUrl
      } else {
        const prefixUrl = this.merchantUrl.split('//', 2)
        url = `${prefixUrl[0]}//${this.currentMerchant.alias}.${prefixUrl[1]}`
        // url = `${prefixUrl[0]}//${this.currentMerchant.alias}.${prefixUrl[1]}/reservation/`
      }
      return url
    },
    homeServicePrepaidUrl() {
      return `${this.productBaseBookingUrl}/${this.storeType}/prepaid/${this.$t('prepaid.BASE')}網址別名`
    },
    storeType() {
      return `商店類型`
    },
  },
  created() {},
  methods: {
    deleteSave() {
      if (this.isEditMode) {
        this.$emit('update')
      }
    },
    validate() {
      return this.$refs.form.validate()
    },
    checknum() {
      this.$refs.form.validateField('infinity')
    },
    changeiInfinity(val) {
      const reg = /^\d+$/
      if (val === 1 && !reg.test(this.submitData.inventory)) {
        this.submitData.inventory = 0
      }
    },
    /*  handleInputSlogan(value) {
      const MAX_DIGIT_PER_LINE = 32
      const MAX_LINES = 3

      const valueLinesArray = value.split('\n')

      let filterLinesArray = valueLinesArray.map((line) => {
        function getOverflowIndex(string, maxDigit) {
          let digitCounter = 0

          for (let index = 0; index < string.length; index++) {
            if (digitCounter >= maxDigit) return index
            const isChinese = string.charCodeAt(index) > 255
            digitCounter += isChinese ? 2 : 1
          }
          return maxDigit
        }

        return line.substring(0, getOverflowIndex(line, MAX_DIGIT_PER_LINE))
      })

      if (filterLinesArray.length > MAX_LINES)
        filterLinesArray.splice(MAX_LINES)
      this.submitData.slogan = filterLinesArray.join('\n')
    }, */
  },
}
</script>

<template>
  <div :class="$style.pageContent">
    <div class="isStylePageContent">
      <el-form ref="form" :model="submitData" :rules="formRules" :validate-on-rule-change="false" label-position="top" :class="$style.form" autocomplete="off">
        <!-- <h4 class="form-block-title">是否開放購買與顯示</h4>
        <el-row>
          <el-col :span="12">
            <el-form-item label="開放購買" prop="state">
              <el-switch
                v-model="submitData.state"
                active-text="開放"
                inactive-text="關閉"
                :active-value="1"
                :inactive-value="0"
              ></el-switch>
            </el-form-item>
          </el-col>
          <el-col v-if="submitData.state === 1" :span="12">
            <el-form-item label="在商店首頁" prop="hidden">
              <el-switch
                v-model="submitData.hidden"
                active-text="顯示"
                :active-value="0"
                inactive-text="隱藏"
                :inactive-value="1"
              ></el-switch>
            </el-form-item>
          </el-col>
        </el-row> -->

        <h4 class="form-block-title">基本設定</h4>

        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item :label="`${$t('prepaid.BASE')}方案名稱`" prop="title" required>
              <el-input v-model="submitData.title" class="bg-white is-border" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="類別" prop="categoryId" required>
              <el-select v-model="submitData.categoryId" :disabled="isEditMode">
                <el-option v-for="(item, index) in currentCategory" :key="`category-${index}`" :label="item.title" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="服務分類">
              <el-select v-model="submitData.tagIds" multiple placeholder="選擇標籤">
                <el-option v-for="(tag, index) in tagList.items" :key="index" :label="tag.title" :value="tag.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24" :sm="24">
            <el-form-item label="購買項目抵扣次數" prop="times" required>
              <el-input v-model.number="submitData.times" min="0" class="bg-white is-border">
                <template v-slot:append>次</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="">
              <span slot="label" for=""
                >購買項目使用期限<span class="text-text-light">(輸入0表示可以無限期使用)</span>
                <el-tooltip content="如限制方案須於購買後一年內使用完畢，請輸入數字365；一個月內則輸入30。" placement="right"> <BaseIcon name="info-circle" class="text-text-light ml-2" /> </el-tooltip
              ></span>
              <el-input v-model="submitData.expireDays" class="bg-white is-border"
                ><template v-slot:append
                  >天</template
                ></el-input
              >
            </el-form-item>
          </el-col>
          <!-- 包月贈送功能(施工中) -->
          <el-col :span="24" :sm="24">
            <el-form-item label="贈送項目抵扣次數" >
              <el-input v-model.number="submitData.bonusTimes" min="0" class="bg-white is-border">
                <template v-slot:append
                  >次</template
                >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="">
              <span slot="label" for=""
                >贈送項目使用期限<span class="text-text-light">(輸入0表示可以無限期使用)</span>
                <el-tooltip content="如限制方案須於購買後一年內使用完畢，請輸入數字365；一個月內則輸入30。" placement="right"> <BaseIcon name="info-circle" class="text-text-light ml-2" /> </el-tooltip
              ></span>
              <el-input v-model="submitData.bonusExpireDays" min="0" class="bg-white is-border"
                ><template v-slot:append
                  >天</template
                ></el-input
              >
            </el-form-item>
          </el-col>
          <el-col :span="24" :sm="24">
            <el-form-item label="庫存數量" prop="infinity" required>
              <div :class="$style['form-item--split']">
                <el-radio-group v-model="submitData.infinity" class="isStyleBorderRound isBig w-100 isInputInside" @change="changeiInfinity">
                  <el-row :gutter="20">
                    <el-col :sm="12" :span="24">
                      <el-radio :label="1" border>無上限</el-radio>
                    </el-col>
                    <el-col :sm="12" :span="24">
                      <el-radio :label="0" border class="isInputInside">
                        限量
                        <el-form-item class="isStyleInside">
                          <el-input v-model.number="submitData.inventory" :disabled="submitData.infinity === 1" :min="0" size="small" class="isStyleInside" @blur="checknum" @input="checknum">
                            <template v-slot:append
                              >張</template
                            >
                          </el-input>
                        </el-form-item>
                        <!-- <el-input v-model.number="submitData.inventory" :disabled="submitData.infinity === 1" min="100" size="small" class="isStyleInside">
                          <template v-slot:append
                            >張</template
                          >
                        </el-input> -->
                      </el-radio>
                    </el-col>
                  </el-row>
                </el-radio-group>
              </div>
            </el-form-item>
          </el-col>

          
          <el-col :span="24">
            <el-form-item label="優惠內容" prop="slogan">
              <el-input v-model="submitData.slogan" type="textarea" :autosize="{ minRows: 3 }" class="bg-white is-border is-round" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="方案內容說明" prop="description">
              <el-input v-model="submitData.description" type="textarea" :autosize="{ minRows: 2 }" class="bg-white is-border is-round" />
            </el-form-item>
          </el-col>
          <!-- <el-col :span="24" :sm="12">
            <el-form-item label="方案圖片" prop="image">
              <template v-if="!$hasSpecial()">
                <BaseUpload
                  v-model="submitData.image"
                  resource="prepaid"
                  suggest-size="360/270"
                  image-size="4:3"
                />
              </template>
              <template v-if="$hasSpecial()">
                <BaseUpload
                v-model="submitData.image"
                resource="prepaid"
                suggest-size="720/350"
              />
              </template>

          </el-col> -->
          <el-col :span="24">
            <el-form-item label="注意事項" prop="notice">
              <el-input v-model="submitData.notice" type="textarea" :autosize="{ minRows: 2 }" class="bg-white is-border is-round" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>
<style lang="scss" module>
@import '@src/design/layout_detail_steps.scss';
.form {
  :global {
    .el-input-group__prepend {
      padding-left: 0;
    }
  }
}
%img-size {
  width: calc(33.333333% - 10px);
  height: 175px;
  @include max-sm {
    width: calc(100% - 10px);
  }
}
:global {
  :local(.upload) {
    margin: 0 -10px;
    border-top: none !important;
    > div {
      @extend %img-size;
    }

    .image-and-action {
      @extend %img-size;
      & + div {
        @extend %img-size;
      }
    }
  }
}
.form-item--split {
  display: flex;
  align-items: center;
  height: 40px;
  line-height: 40px;

  :global {
    .el-radio-group {
      flex-shrink: 0;
      margin-right: 15px;
    }
    .el-input {
      // max-width: 150px;
    }
  }
}
</style>
